import React from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import './Works.scss'
import { images } from '../../constants'

const Works = () => {
  const { workId } = useParams();
  const navigate = useNavigate();
  const handleWork = () => {
    navigate('/work');
  };

  const works = [
    { id: '01', title: 'MakeNTU KV', description: 'GRAPHIC DESIGN', img: images.makentupage },
    { id: '02', title: 'MY PAINTING COLLECTION', description: 'PAINTING', img: images.paintingpage },
    { id: '03', title: 'Culture ToGather', description: 'UI/UX FRONTEND', img: images.culturepage },
    { id: '04', title: 'NTUEE night KV', description: 'GRAPHIC DESIGN', img: images.ntueenightpage },
  ];

  const work = works.find((item) => item.id === workId);

  if (!work) {
    return <div>work not found</div>;
  }

  return (
    <div className='works-page'>
      <img src={work.img} alt={work.id} />
      <div className='works-page-lower'>
        <div className='works-page-back-to-work' onClick={() => handleWork()}>
          <div className='back-to-work-circle' style={{backgroundColor:'rgb(224, 224, 224)'}}/>
          <i class="fas fa-sharp fa-solid fa-chevron-left"></i>
          <p>BACK TO WORKS</p>
        </div>
        <h4>{work.title}</h4>
        <h5>{work.description}</h5>
      </div>
    </div>
  );
};

export default Works